export default function ReviewSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="relative bg-foreground-950 rounded-[2.5rem] overflow-visible">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-2/5 relative -mt-10 lg:-mt-12 lg:-ml-8 mb-6 lg:mb-0">
              <div className="aspect-[3/4] lg:aspect-auto lg:h-full rounded-[2rem] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20neutral%20toned%20fashion%20editorial%20portrait%20style%20image%2C%20soft%20minimalist%20product%20display%20on%20cream%20background%2C%20elegant%20composition%20with%20gentle%20shadows%2C%20high%20end%20aesthetic%2C%20warm%20ambient%20lighting%2C%20professional%20product%20photography%2C%20taupe%20and%20beige%20tones&width=900&height=1200&seq=testimonial-img-01&orientation=portrait"
                  alt="Отзыв"
                  className="w-full h-full object-cover object-top rounded-[2rem]"
                />
              </div>
            </div>

            <div className="lg:w-3/5 flex items-center px-8 md:px-14 py-12 md:py-16 lg:py-20">
              <div>
                <div className="text-accent-400 text-7xl md:text-8xl font-heading leading-none mb-4">
                  &ldquo;
                </div>
                <blockquote className="text-background-50 text-lg md:text-xl leading-relaxed mb-8 font-light">
                  YOYBUY Spreadsheet стал для меня настоящим открытием. Теперь я могу легко отслеживать все свои заказы, сравнивать цены и находить лучшие предложения. Интерфейс интуитивно понятный, а функционал превосходит ожидания.
                </blockquote>
                <div className="mb-8">
                  <p className="text-background-50 text-sm font-semibold">Анна К.</p>
                  <p className="text-foreground-400 text-xs mt-1">Постоянный покупатель</p>
                </div>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 bg-accent-500 text-background-50 px-7 py-3.5 rounded-full text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Попробовать сейчас
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}